module.exports = __webpack_public_path__ + "static/img/aiot.3d38267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/aiot.png
// module id = 581
// module chunks = 70